module.exports = __webpack_public_path__ + "assets/img/b69a-kg.svg";